import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { FeedResponse } from '../response/feed.response';
import { GeneralService } from './general.service';
import { Feed } from '../model/feed';
import { FeedDailyColumns } from '../model/feed-daily-columns';
import { DailygridsColumns } from '../model/dailygrids-column';

@Injectable({
    providedIn: 'root'
})
export class FeedService {
    [x: string]: any;

    constructor(
        private http: HttpClient,
        private gralService: GeneralService) {
    }

    getFeeds$(): Observable<Feed[]> {
        this.http.get<FeedResponse>(environment.apiDomainUrlGetFeed).pipe(map(response => response.feeds),catchError(this.gralService.handleError))
        //console.log("****"+ environment.apiDomainUrlGetFeed);
        return this.http.get<FeedResponse>(environment.apiDomainUrlGetFeed).pipe(map(response => response.feeds),catchError(this.gralService.handleError));
    }

    getFeedsAndDailyColumns(): Observable<FeedDailyColumns[]>{
        return this.http.get<FeedDailyColumns[]>(environment.apiDomainUrlGetFeedWithColumns).pipe(
            catchError(this.gralService.handleError)
          );

    }

    getAllDailygridsColumns(): Observable<DailygridsColumns[]>{
        return this.http.get<DailygridsColumns[]>(environment.apiDomainUrlGetAllDailygridsColumns).pipe(
            catchError(this.gralService.handleError)
          );

    }

    setDailygridsColumnsForFeed(feedAndColumns: FeedDailyColumns): Observable<DailygridsColumns[]>{
        return this.http.post<DailygridsColumns[]>(`${environment.apiDomainUrlSetDailygridsColumns}/updateColumns`,feedAndColumns).pipe(
            catchError(this.gralService.handleError)
          );

    }

   createDailygridsColumns(): Observable<DailygridsColumns[]>{
        return this.http.get<DailygridsColumns[]>(environment.apiDomainUrlGetAllDailygridsColumns).pipe(
            catchError(this.gralService.handleError)
          );

    }

     addDailygridsColumn(column: DailygridsColumns): Observable<DailygridsColumns> {
        return this.http.post<DailygridsColumns>(`${environment.apiDomainUrlGetAllDailygridsColumns}/save`, column).pipe(
          catchError(this.gralService.handleError)
        );
      }
    
      updateDailygridsColumn(id: number, column: DailygridsColumns): Observable<DailygridsColumns> {
        return this.http.put<DailygridsColumns>(`${environment.apiDomainUrlGetAllDailygridsColumns}/update/${id}`, column).pipe(
          catchError(this.gralService.handleError)
        );
      }

      deleteDailygridsColumn(id: number): Observable<void> {
        return this.http.delete<void>(`${environment.apiDomainUrlGetAllDailygridsColumns}/delete/${id}`).pipe(
          catchError(this.gralService.handleError)
        );
      }
}
